import React, { useEffect }  from 'react';
import Lottie from 'react-lottie';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Box,
  Heading,
  Button,
} from '@chakra-ui/react';
import animationData from '../assets/AnimationCom.json';

interface UserCreateSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  
}

const UserCreateSuccessModal: React.FC<UserCreateSuccessModalProps> = ({ isOpen, onClose}) => {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  useEffect(() => {
    if (isOpen) {
        // Send a message to the parent window to scroll to the top
        window.parent.postMessage({ action: 'scrollToTop' }, '*');
    }
}, [isOpen]);

  const handleReturnHome = () => {
    onClose();
    
  };

 
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" blockScrollOnMount={false} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Box textAlign="center">
            <Heading as='h3' mt={10} size='lg'> Successful! </Heading>
            <Lottie options={defaultOptions} height={300} width={300} />
            {/* <Text fontSize="lg" mt={4}>
              Done successfully.
            </Text> */}
            
            <Button
              bg="#B92F2F"
              color="#fff"
              borderRadius={30}
              size="md"
              fontSize="sm"
              mt={5}
              mb={5}
              onClick={handleReturnHome}
            >
              Done
            </Button>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default UserCreateSuccessModal;
